export const dataGeneratorRoute = 'data-generator';
export const dataGeneratorRunsRoute = `${dataGeneratorRoute}/runs`;
export const dataGeneratorRunByIdRoute = `${dataGeneratorRoute}/runs/:runId`;
export const organizationsRoute = 'organizations';
export const organizationByIdRoute = `${organizationsRoute}/:organizationId`;
export const organizationUsersRoute = `${organizationByIdRoute}/users`;
export const organizationLogoUploadRoute = `${organizationByIdRoute}/logo-upload`;
export const organizationSecretsRoute = `${organizationByIdRoute}/secrets`;
export const organizationSecretByIdRoute = `${organizationSecretsRoute}/:secretId`;
export const usersRoute = 'users';
export const userByIdRoute = `${usersRoute}/:userId`;
export const databasesRoute = `${organizationByIdRoute}/databases`;
export const databaseByIdRoute = `${databasesRoute}/:databaseId`;
export const databaseByIdDataSync = `${databaseByIdRoute}/sync-data`;
export const schedulesRoute = 'schedules';
export const databaseByIdSchedule = `${databaseByIdRoute}/schedule`;
export const databaseByIdScheduleRuns = `${databaseByIdRoute}/schedule/runs`;
export const databaseByIdScheduleV2 = `v2/${databaseByIdRoute}/schedule`;
export const databaseByIdSchedulesV2 = `v2/${databaseByIdRoute}/schedules`;
export const databaseByIdScheduleByIdV2 = `v2/${databaseByIdRoute}/schedule/:scheduleId`;
export const databaseByIdScheduleByIdRunsV2 = `${databaseByIdScheduleByIdV2}/runs`;
export const databaseByIdScheduleByIdRunsV2Metrics = `${databaseByIdScheduleByIdRunsV2}/metrics/:runId`;
export const databaseByIdScheduleByIdSyncV2 = `${databaseByIdScheduleByIdV2}/sync`;
export const databaseRevisionsRoute = `${databaseByIdRoute}/revisions`;
export const databaseRevisionsByIdRoute = `${databaseRevisionsRoute}/:databaseRevisionId`;
export const databaseRevisionsByIdSchemaOptions = `${databaseRevisionsByIdRoute}/schema-options`;
export const databaseByIdRubricBankItems = `${databaseByIdRoute}/rubric-bank-items`;
export const databaseByIdRubricBankItemsById = `${databaseByIdRubricBankItems}/:rubricBankItemId`;
export const databaseByIdRubricBankConstructs = `${databaseByIdRoute}/rubric-bank-constructs`;
export const databaseByIdRubricBankConstructsById = `${databaseByIdRubricBankConstructs}/:rubricBankConstructId`;
export const databaseRevisionsByIdRubrics = `${databaseRevisionsByIdRoute}/rubrics`;
export const databaseRevisionsByIdRubricsById = `${databaseRevisionsByIdRubrics}/:rubricId`;
export const databaseRevisionsByIdRubricsByIdStatus = `${databaseRevisionsByIdRubricsById}/status`;
export const databaseRevisionsByIdRubricsByIdDuplicate = `${databaseRevisionsByIdRubricsById}/duplicate`;
export const databaseRevisionsByIdRubricsRoles = `${databaseRevisionsByIdRubrics}/roles`;
export const databaseRevisionsByIdRubricsTags = `${databaseRevisionsByIdRubrics}/tags`;
export const databaseRevisionsByIdRubricsCategories = `${databaseRevisionsByIdRubrics}/categories`;
export const databaseByIdMergeRealTimeWritebackConfigs = `${databaseByIdRoute}/merge-realtime-writeback-configs`;
export const databaseByIdMergeRealTimeWritebackConfigById = `${databaseByIdMergeRealTimeWritebackConfigs}/:mergeRealtimeWritebackConfigId`;
export const databaseByIdFeatureFlags = `${databaseByIdRoute}/feature-flags`;
export const transformsRoute = `${databaseByIdRoute}/transforms`;
export const transformRoute = `${transformsRoute}/:transformId`;
export const transformScriptRoute = `${transformRoute}/script`;
export const transformCompareRoute = `${transformRoute}/compare`;
export const transformDataSummaryRoute = `${transformRoute}/data-summary`;
export const transformDictionaryRoute = `${transformRoute}/dictionary`;
export const transformDagRoute = `${transformRoute}/dag`;
export const databaseRevisionsByIdPublish = `${databaseRevisionsByIdRoute}/publish`;
export const databaseRevisionsByIdGenerateNlpQuery = `${databaseRevisionsByIdRoute}/nlp-query`;
export const databaseRevisionsByIdRunCopilotModelExperimentation = `${databaseRevisionsByIdRoute}/copilot-model-experimentation`;
export const databaseCopilotModelExperimentationExecutionIdRoute = `${databaseRevisionsByIdRoute}/copilot-model-experimentation/:executionId`;
export const explainImageRoute = `explain/image`;
export const apiMetaInformationRoute = `info`;
export const apiNoopRoute = `noop`;

export const databaseRevisionsByIdOverviewPageConfiguration = `${databaseRevisionsByIdRoute}/overview-page-configuration`;
export const adminRoute = 'admin';
export const adminUsersRoute = `${adminRoute}/users`;
export const adminUserByIdRoute = `${adminRoute}/users/:userId`;
export const adminSsoRoute = `${adminRoute}/sso`;
export const identityProvidersRoute = `${adminSsoRoute}/identity-providers`;
export const identityProviderByIdRoute = `${identityProvidersRoute}/:identityProviderId`;
export const roleMappingsRoute = `${identityProviderByIdRoute}/role-mappings`;
export const roleMappingRoute = `${roleMappingsRoute}/role-mapping`;
export const suppressionsRoute = `${adminRoute}/suppressions`;
export const featureFlagsRoute = `feature-flags`;

export const dataSetsRoute = `${databaseByIdRoute}/data-sets`;
export const organizationDataSetsRoute = `${organizationByIdRoute}/data-sets`;

export const dataSetByIdRoute = `${dataSetsRoute}/:dataSetId`;
export const dataSetByIdReportInsights = `${dataSetByIdRoute}/report-insights`;
export const dataSetVersionsRoute = `${dataSetByIdRoute}/versions`;
export const dataSetVersionsByIdFilesRoute = `${dataSetVersionsRoute}/:dataSetVersion/files`;
export const dataSetVersionPostProcessingRoute = `${dataSetByIdRoute}/versions/:dataSetVersion/post-processing`;
export const dataSetVersionsFullRoute = `${databaseByIdRoute}/data-set-versions-full`;
export const dataSetPostProcessingScriptRoute = `${dataSetByIdRoute}/post-processing-script`;
export const userUploadsRoute = `${userByIdRoute}/uploads`;

export const userAnalysesRoute = `user-analyses/organizations/:organizationId/databases/:databaseId/revisions/:databaseRevisionId/analyses`;

export const generateReportRoute = `${databaseRevisionsByIdRoute}/reports`;
export const queryReportRoute = `${databaseRevisionsByIdRoute}/reports/:reportId`;

export const userAnalysisByIdRoute = `${userAnalysesRoute}/:userAnalysisId`;

export const mergeRoute = 'merge';

export const savedAnalysisRoute = `saved-analysis`;
export const savedAnalysisByCustomVizRequestRoute = `${savedAnalysisRoute}/custom-viz-request`;

export const deprecatedEmbedDashboardRoute = 'embed-dashboard';
export const deprecatedEmbedDashboardByIdRoute = `${deprecatedEmbedDashboardRoute}/:dashboardId`;

export const dashboardsRoute = `${databaseRevisionsByIdRoute}/dashboards`;
export const dashboardDetailsRoute = `${dashboardsRoute}/:dashboardId`;

export const generateDashboardAISummaryRoute = `${dashboardDetailsRoute}/dashboard-ai-summary`;
export const queryDashboardAISummaryRoute = `${dashboardDetailsRoute}/dashboard-ai-summary/:dashboardAISummaryId`;

export const duplicateDashboardRoute = `${dashboardDetailsRoute}/duplicate`;
export const dashboardChartsRoute = `${dashboardDetailsRoute}/charts`;
export const dashboardChartDetailsRoute = `${dashboardChartsRoute}/:dashboardChartId`;
export const dashboardMoveChartRoute = `${dashboardChartDetailsRoute}/move`;
export const dashboardExternalUsersRoute = `${dashboardDetailsRoute}/external-users`;
export const dashboardExternalUserByIdRoute = `${dashboardExternalUsersRoute}/:dashboardExternalUserId`;
export const dashboardExternalUserResendInvitationRoute = `${dashboardExternalUserByIdRoute}/resend-invitation`;
export const dashboardExternalUserRevokeAccessRoute = `${dashboardExternalUserByIdRoute}/revoke`;

export const groupsRoute = 'groups';
export const groupByIdRoute = `${groupsRoute}/:groupId`;
export const groupUsersRoute = `${groupByIdRoute}/users`;
export const groupUserByIdRoute = `${groupByIdRoute}/users/:groupUserId`;
export const groupEntitlementsRoute = `${groupByIdRoute}/entitlements`;

export const auditsRoute = 'audits';

export const organizationPrivateNetworkingEntitlementsRoute =
  'organization-private-networking-entitlements';
export const organizationPrivateNetworkingEntitlementByIdRoute = `${organizationPrivateNetworkingEntitlementsRoute}/:entitlementId`;
export const allOrganizationPrivateNetworkingEntitlementsRoute =
  'organization-private-networking-entitlements';

export const streamlitAppsRoute = 'external-streamlit-apps';
export const streamlitAppSignedUrlRoute = `${streamlitAppsRoute}/signed-url`;
export const streamlitAppByIdRoute = `${streamlitAppsRoute}/:streamlitAppId`;
export const streamlitAppsByOrganizationRoute = `${organizationsRoute}/:organizationId/streamlit-apps`;
export const streamlitAppOrganizationsRoute = `${streamlitAppByIdRoute}/organizations`;
export const streamlitAppGrantAccessRoute = `${streamlitAppsRoute}/grant-access`;
export const streamlitAppRevokeAccessRoute = `${streamlitAppsRoute}/revoke-access`;

export const dagsterTransformsRoute = 'external-dagster-transforms';
export const dagsterTransformByIdRoute = `${dagsterTransformsRoute}/:dagsterTransformId`;
export const dagsterTransformEntitlementsByIdRoute = `${dagsterTransformByIdRoute}/entitlements`;
export const dagsterTransformsByOrganizationRoute = `${organizationsRoute}/:organizationId/dagster-transforms`;
export const dagsterTransformGrantAccessRoute = `${dagsterTransformsRoute}/grant-access`;
export const dagsterTransformRevokeAccessRoute = `${dagsterTransformsRoute}/revoke-access`;

export const browserAgentRoute = 'browser-agent';

export const browserAgentAdpRoute = `${browserAgentRoute}/adp`;
export const browserAgentAdpCandidatesRoute = `${browserAgentAdpRoute}/candidates`;
export const browserAgentAdpCandidateEmailsRoute = `${browserAgentAdpCandidatesRoute}/emails`;
export const browserAgentAdpCandidateGradesRoute = `${browserAgentAdpCandidatesRoute}/grades`;
export const browserAgentAdpCandidateByIdRoute = `${browserAgentAdpCandidatesRoute}/:id`;
export const browserAgentAdpCandidateByIdSuccessRoute = `${browserAgentAdpCandidateByIdRoute}/success`;
export const browserAgentAdpReadinessScoresRoute = `${browserAgentAdpRoute}/readiness-scores`;
export const browserAgentAdpReadinessDeliverySuccessRoute = `${browserAgentAdpRoute}/readiness-deliveries/:deliveryId/success`;

export const browserAgentWritebackRoute = `${browserAgentRoute}/writeback`;
export const browserAgentWritebackEntitiesRoute = `${browserAgentWritebackRoute}/entities`;
export const browserAgentWritebackEntityByIdSuccessRoute = `${browserAgentWritebackEntitiesRoute}/:writeBackEntityId/success`;

export const browserAgentMfaRoute = `${browserAgentRoute}/mfa`;
export const browserAgentMfaPollRoute = `${browserAgentMfaRoute}/poll`;
export const browserAgentMfaMarkAsUsedRoute = `${browserAgentMfaRoute}/:id/use`;

export const browserAgentCreateApplicantResumeRoute = `${browserAgentRoute}/applicants/:applicantId/resume`;
export const browserAgentGradeResumesRoute = `${browserAgentRoute}/resumes/grade`;

export const externalStreamlitRoute = `external-streamlit`;
export const externalStreamlitValidateSignedTokenRoute = `${externalStreamlitRoute}/validate-signed-token`;

export const healthRoute = 'health';

export const mergeInternalRoute = `merge/internal`;
export const mergeInternalPassthroughRoute = `${mergeInternalRoute}/passthrough`;

export const customVizV2Route = `v2/custom-viz`;
export const customVizV2OptionsRoute = `${customVizV2Route}/options`;
export const customVizV2OptionsEmbedDashboardRoute = `${customVizV2OptionsRoute}/embed-dashboard/:dashboardId`;
export const customVizV2VizRoute = `${customVizV2Route}/viz`;
export const customVizV2VizEmbedDashboardRoute = `${customVizV2VizRoute}/embed-dashboard/:dashboardId`;
export const customVizV2PollRoute = `${customVizV2Route}/poll`;
export const customVizV2PollEmbedDashboardRoute = `${customVizV2PollRoute}/embed-dashboard/:dashboardId`;

export const connectionsRoute = `${organizationByIdRoute}/connections`;
export const connectionsConfigurationRoute = `${connectionsRoute}/configuration`;
export const connectionRoute = `${connectionsRoute}/:connectionId`;
export const connectionInstallationRoute = `${connectionRoute}/installation`;
export const connectionInstallationTestRoute = `${connectionRoute}/installation/test`;
export const connectionInstallationRefreshTokenRoute = `${connectionInstallationRoute}/refresh-token`;
export const connectionInstallationRetrieveTokenRoute = `${connectionInstallationRoute}/retrieve-token`;
export const connectionInstallationOAuthInstallRoute = `${connectionInstallationRoute}/oauth-install`;
export const connectionsOAuthCallbackRoute = 'connections/oauth/callback';
export const connectionEnabledOrgsRoute = `${organizationsRoute}/connections/:connectionId/enabled`;

export const chatsRoute = `${databaseRevisionsByIdRoute}/chats`;
export const chatByConversationIdRoute = `${chatsRoute}/chat/:conversationId`;
export const chatsStreamRoute = `${chatsRoute}/stream`;

// Analytics routes (obscure names to avoid adblockers)
export const analyticsRoute = 'p8k3m';
export const analyticsTrackRoute = `${analyticsRoute}/t`;
export const analyticsIdentifyRoute = `${analyticsRoute}/i`;
